
import BasicInfo from "../pages/profile/component/BasicInfo";
import EmployeeProfilePage from "../pages/profile/EmployeeProfilePage";
// import ProfilePage from "../pages/ProfilePage";
import UserReports from "../pages/profile/component/UserReports";
import ManagerDashboard from "../pages/manager/component/ManagerDashboard";
import ManagerView from "../pages/manager/component/ManagerView";
import SuperAdmin from "../pages/SuperAdmin/SuperAdmin";
import LandingPage from "../pages/landing/LandingPage";
import History from "../pages/profile/History";
import Preview from "../pages/profile/component/Preview";
import Step3 from "../pages/RoleReviewer/component/Step3";
import CreateEmployee from "../pages/manager/component/CreateEmployee";
import ViewOrganizations from "../pages/SuperAdmin/ViewOrganizations";
import UsersList from "../pages/SuperAdmin/UsersList";
import UserOrganizationsView from "../pages/SuperAdmin/UserOrganizationsView";
import EditUserOrganizations from "../pages/SuperAdmin/EditUserOrganizations";
import CreateManager from "../pages/manager/component/CreateManager";
import ViewOrg from "../pages/SuperAdmin/ViewOrg";
import EditOrg from "../pages/SuperAdmin/EditOrg";
import ResestPassOrg from "../pages/SuperAdmin/ResestPassOrg";
import OrganizationMembers from "../pages/SuperAdmin/OrganizationMembers";
import WorkData from "../pages/report/component/WorkData";

export const privateRouteList = [
    // {
    //   path: '/forgot-password',
    //   Component: ForgotPasswordPage,
    // },
    // {
    //     path: '/verify-code',
    //     Component: VerifyCode,
    //   },
    //   {
    //     path: '/reset-password',
    //     Component: ResetPasswordForm,
    //   },
      // {
      //   path: '/user_details-steps',
      //   Component: RoleReviewForm,
      // },
      // {
      //   path: '/user_details-stepss/:id',
      //   Component: RoleReviewForm,
      // },
      {
        path: '/employee/profile/:employeeId',
        Component: EmployeeProfilePage,
      },
      {
        path: '/dashboard',
        Component: EmployeeProfilePage,
      },
    //   {
    //     path: '/employee/profile/', // Employee profile main page
    //     Component: EmployeeProfilePage,
    //   },
      {
        path: '/employee/profile/basic-info', // Nested basic info page
        Component: BasicInfo,
      },
      // {
      //   path: '/view', // Nested basic info page
      //   Component: ViewPage,
      // },
      
      {
        path:'/user-reports',
        Component:UserReports,
      },
      {
        path:'/manager-dashboard',
        Component:ManagerDashboard,
      },
      {
        path:'/manager-view/:userId',
        Component:ManagerView,
      },
      {
        path: '/superadmin-dashboard',
        Component: SuperAdmin,
      },
      {
        path: '/landing-page',
        Component: LandingPage,
      },
      {
        path: '/history',
        Component: History,
      },
      {
        path: '/preview',
        Component: Preview,
      },
      {
        path: '/role-review/step3', // Nested basic info page
        Component: Step3,
      },
      {
        path: '/create-employee', // Nested basic info page
        Component: CreateEmployee,
      },
      {
        path: '/view-org', // Nested basic info page
        Component: ViewOrganizations,
      },
      {
        path: '/users/view/:userEmail',
        Component: UserOrganizationsView,
      },
      {
        path: "/users/edit/:userEmail",
        Component: EditUserOrganizations,
      },
      {
        path: '/users',
        Component: UsersList,
      },
      {
        path: '/create-manager', // Nested basic info page
        Component: CreateManager,
      },
      {
        path: '/organizations/:id', // Nested basic info page
        Component: ViewOrg,
      },
      {
        path: '/organizations/:id/edit', // Nested basic info page
        Component: EditOrg,
      },
      
      
      {
        path: '/organizations/:id/reset-password', // Nested basic info page
        Component: ResestPassOrg,
      },
      {
        path: "/organizations/:id/members",
        Component: OrganizationMembers,
      },
      {
        path: '/workdata', // Nested basic info page
        Component: WorkData,
      },

      // {
      //   path: '/complete-registration', // Route for completing registration
      //   Component: CompleteRegistration,
      // },
    // {
    //     path: '/employee/profile/:employeeId',
    //     Component: EmployeeProfilePage, // Main Profile Page
    //     children: [ // Add nested routes for sub-components like BasicInfo
    //       {
    //         path: '', // Default route (same as /employee/profile/:employeeId)
    //         Component: BasicInfo,
    //       },
    //       {
    //         path: 'edit', // Nested route (e.g., /employee/profile/:employeeId/edit)
    //         Component: EditBasicInfo,
    //       },
    //     ],
    //   },

  ];